export default class OrderProductionUtil {
    static getValueByHeader(data, header) {
        // Guard: Ensure data is an array and header is provided
        if (!Array.isArray(data) || !header) {
            return null;
        }

        for (const row of data) {
            // Skip null/undefined rows
            if (row === null || row === undefined) continue;

            // Ensure row.typeJob exists and has a name
            if (row.typeJob && row.typeJob.name === header) {
                return row.completionPercentage;
            }
        }

        return null;
    }
}